module.exports = require("@swa-ui/shopping/src/FareOption/FareOption.module.scss");